import React, { useEffect, useState } from 'react';
import { StrikeThroughHeader } from 'Components/Headers/strikethrough-header/strikethrough-header';
import PropTypes from 'prop-types';
import { CheckPhoneNumber } from 'api/donotcall.js';
import _MaskedInput from 'react-text-mask';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import LoadingIndicator from 'Components/Global/loading-indicator/loading-indicator';
import { useQuery } from '@tanstack/react-query';

const MaskedInput = _MaskedInput.default ?? _MaskedInput;

export default function DoNotCall() {
  //#region variables
  const [phoneList, setPhoneList] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState('');
  //#endregion

  //#region functions
  const VerifyPhoneNumber = (val) => {
    var chars = { '(': '', ')': '', '-': '' };

    var str = val.toString();
    str = str.replace(/[()-]/g, (m) => chars[m]); //remove the unwanted chars
    str = str.replace(/ /g, ''); //and string
    str = str.trim();

    var phoneObj = {};
    phoneObj['PhoneNumber'] = str;
    phoneObj['Label'] = val;

    let lst = [...phoneList, phoneObj];
    setPhoneList(lst);

    setPhoneNumber('');
  };
  //#endregion

  return (
    <div>
      <StrikeThroughHeader>Do Not Call</StrikeThroughHeader>
      <div
        style={{ maxHeight: '50em', overflowY: 'auto', overflowX: 'hidden', minHeight: '300px' }}
      >
        <div className="row">
          <div className="col-3" style={{ margin: 'auto 0 auto 0' }}>
            <MaskedInput
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              className="form-control"
              placeholder="(XXX) XXX-XXXX"
              guide={true}
              id="my-input-id"
              value={phoneNumber}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  VerifyPhoneNumber(phoneNumber);
                }
              }}
              onBlur={(e) => {
                setPhoneNumber(e.target.value);
              }}
              onChange={(e) => {
                setPhoneNumber(e.target.value);
              }}
              variant="outlined"
              margin="dense"
            />
          </div>
          <div className="col-3">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                VerifyPhoneNumber(phoneNumber);
              }}
            >
              Submit
            </button>
          </div>
        </div>
        <hr />

        <div>
          <div className="row">
            <div className="col">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {phoneList.map((e, i) => (
                    <PhoneListRow key={i + 'row'} value={e} />
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

//#region UI functions
function PhoneListRow({ value }) {
  const [dncStatus, setDNCStatus] = useState(null);
  const checkPhoneNumberQuery = useQuery({
    queryKey: ['checkPhoneNumber', value.PhoneNumber],
    queryFn: () => CheckPhoneNumber({ PhoneNumber: value.PhoneNumber })(),
  });

  useEffect(() => {
    if (checkPhoneNumberQuery.data) {
      let d = JSON.parse(checkPhoneNumberQuery.data);
      setDNCStatus(d != null ? (d['PhoneNumberFound'] === 1 ? true : false) : null);
    }
  }, [checkPhoneNumberQuery.data]);

  return (
    <tr>
      <td>{value.Label}</td>
      <>
        {checkPhoneNumberQuery.isPending ? (
          <td style={{ width: '15em' }}>
            <div>
              <LoadingIndicator
                style={{
                  width: '100%',
                  height: '100%',
                  textAlign: 'center',
                }}
              />
            </div>
          </td>
        ) : (
          <>
            {dncStatus != null ? ( //if we don't have an error
              dncStatus == false ? ( //can be called status
                <td className="bg-primary" style={{ width: '15em', height: '100%' }}>
                  <div className="text-white text-center">
                    <DoneIcon />
                    Can be Called
                  </div>
                </td> //can't be called status
              ) : (
                <td className="bg-danger" style={{ width: '15em', height: '100%' }}>
                  <div className="text-white text-center">
                    <CloseIcon />
                    Cannot be Called
                  </div>
                </td>
              )
            ) : (
              //if the dncstatus returns an error
              <td className="bg-danger" style={{ width: '15em', height: '100%' }}>
                <div className="text-white text-center">
                  <CloseIcon />
                  Error
                </div>
              </td>
            )}
          </>
        )}
      </>
    </tr>
  );
}

PhoneListRow.propTypes = {
  value: PropTypes.object,
};
//#endregion
